module.exports = new __parcel__URL__("love.560a684f.jpg").toString();